import { DashboardApi } from "./dashboard-api";
import { DashboardForm } from "./dashboard-form";
import { DashboardHandler } from "./dashboard-handler";
import { DashboardListener } from "./dashboard-listener";
import { DashboardRender } from "./dashboard-render";

export class DashboardSetup {
    private readonly form: DashboardForm;

    private readonly api: DashboardApi;

    private readonly render: DashboardRender;

    private readonly handler: DashboardHandler;

    private readonly listener: DashboardListener;

    public constructor(root: HTMLElement) {
        this.form = new DashboardForm(root);
        this.api = new DashboardApi();
        this.render = new DashboardRender();
        this.handler = new DashboardHandler(this.form, this.api, this.render);
        this.listener = new DashboardListener(this.form, this.handler, this.render);
    }

    public async init(): Promise<void> {
        if (this.form.isInitialized()) {
            return;
        }

        this.listener.register();
        await this.handler.bootstrap();
        this.form.markInitialized();
    }

    public static async init(scope: Document | HTMLElement | ParentNode = document): Promise<void> {
        for (const target of DashboardForm.getRoots(scope)) {
            const setup = new DashboardSetup(target);
            await setup.init();
        }
    }
}
